import uniquifyObject from '@utils/uniquifyObject'
import {
  json as SignupImageColumnTemplate,
  info as SignupImageColumnInfo,
} from './Signup_imageColumn'
import {
  json as WeeklyDesignInspirationTemplate,
  info as WeeklyDesignInspirationInfo,
} from './Weekly-Design-Inspiration_oneColumn'
import {
  json as PromoCodeFortuneWheelTemplate,
  info as PromoCodeFortuneWheelInfo,
} from './PromoCode_fortuneWheel'
import {
  json as DiscountOneColumnTemplate,
  info as DiscountOneColumnInfo,
} from './Discount_oneColumn'
import {
  json as StayInTuneImageColumnTemplate,
  info as StayInTuneImageColumnInfo,
} from './Stay-Tune-Subscription_imageColumn'
import {
  json as CustomerFeedbackNetPromoterOneColumnTemplate,
  info as CustomerFeedbackNetPromoterOneColumnInfo,
} from './Customer-Feedback-Net-Promoter_oneColumn'
import {
  json as SpecialOfferOneColumnTemplate,
  info as SpecialOfferOneColumnInfo,
} from './Special-Offer_oneColumn'
import {
  json as WebsiteFeedbackOneColumnTemplate,
  info as WebsiteFeedbackOneColumnInfo,
} from './Website-Feedback_oneColumn'
import {
  json as MysteryGiftOneColumnTemplate,
  info as MysteryGiftOneColumnInfo,
} from './Mystery-Gift_oneColumn'

import {
  json as OnvocadoFortuneWheelTemplate,
  info as OnvocadoFortuneWheelInfo,
} from './Onvocado_fortuneWheel'

import {
  json as OnvocadoNetPromoterTemplate,
  info as OnvocadoNetPromoterInfo,
} from './Onvocado-Net-Promoter_oneColumn'

import {
  json as BFFortuneWheelTemplate,
  info as BFFortuneWheelInfo,
} from './Black-Friday_fortuneWheel'

import {
  json as BFImageColumnTemplate,
  info as BFImageColumnInfo,
} from './Black-Friday_imageColumn'

import {
  json as BFOneColumnTemplate,
  info as BFOneColumnInfo,
} from './Black-Friday_oneColumn'

const SignupImageColumn = {
  json: uniquifyObject(JSON.parse(JSON.stringify(SignupImageColumnTemplate))),
  info: SignupImageColumnInfo,
}

const WeeklyDesignInspiration = {
  json: uniquifyObject(
    JSON.parse(JSON.stringify(WeeklyDesignInspirationTemplate))),
  info: WeeklyDesignInspirationInfo,
}

const TestFortuneWheel = {
  json: uniquifyObject(
    JSON.parse(JSON.stringify(PromoCodeFortuneWheelTemplate))),
  info: PromoCodeFortuneWheelInfo,
}

const DiscountOneColumn = {
  json: uniquifyObject(JSON.parse(JSON.stringify(DiscountOneColumnTemplate))),
  info: DiscountOneColumnInfo,
}

const StayInTuneImageColumn = {
  json: uniquifyObject(
    JSON.parse(JSON.stringify(StayInTuneImageColumnTemplate))),
  info: StayInTuneImageColumnInfo,
}

const CustomerFeedbackNetPromoterOneColumn = {
  json: uniquifyObject(
    JSON.parse(JSON.stringify(CustomerFeedbackNetPromoterOneColumnTemplate))),
  info: CustomerFeedbackNetPromoterOneColumnInfo,
}

const SpecialOfferOneColumn = {
  json: uniquifyObject(
    JSON.parse(JSON.stringify(SpecialOfferOneColumnTemplate))),
  info: SpecialOfferOneColumnInfo,
}

const WebsiteFeedbackOneColumn = {
  json: uniquifyObject(
    JSON.parse(JSON.stringify(WebsiteFeedbackOneColumnTemplate))),
  info: WebsiteFeedbackOneColumnInfo,
}

const MysteryGiftOneColumn = {
  json: uniquifyObject(
    JSON.parse(JSON.stringify(MysteryGiftOneColumnTemplate))),
  info: MysteryGiftOneColumnInfo,
}

const OnvocadoFortuneWheel = {
  json: uniquifyObject(
    JSON.parse(JSON.stringify(OnvocadoFortuneWheelTemplate))),
  info: OnvocadoFortuneWheelInfo,
}

const OnvocadoNetPromoter = {
  json: uniquifyObject(
    JSON.parse(JSON.stringify(OnvocadoNetPromoterTemplate))),
  info: OnvocadoNetPromoterInfo,
}

const BFFortuneWheel = {
  json: uniquifyObject(
    JSON.parse(JSON.stringify(BFFortuneWheelTemplate))),
  info: BFFortuneWheelInfo,
}

const BFImageColumn = {
  json: uniquifyObject(
    JSON.parse(JSON.stringify(BFImageColumnTemplate))),
  info: BFImageColumnInfo,
}

const BFOneColumn = {
  json: uniquifyObject(
    JSON.parse(JSON.stringify(BFOneColumnTemplate))),
  info: BFOneColumnInfo,
}


export default [
  BFFortuneWheel,
  BFImageColumn,
  BFOneColumn,
  SignupImageColumn,
  OnvocadoFortuneWheel,
  OnvocadoNetPromoter,
  StayInTuneImageColumn,
  CustomerFeedbackNetPromoterOneColumn,
  MysteryGiftOneColumn,
  TestFortuneWheel,
  SpecialOfferOneColumn,
  DiscountOneColumn,
  WeeklyDesignInspiration,
  WebsiteFeedbackOneColumn,

]
